"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.accountNameExist = accountNameExist;
exports.addSubAccount = addSubAccount;
exports.addSubAccountRolePort = addSubAccountRolePort;
exports.deleteSubAccountRolePort = deleteSubAccountRolePort;
exports.getLockSubAccount = getLockSubAccount;
exports.getQueryEbSysAccountSub = getQueryEbSysAccountSub;
exports.getQueryRoleByAccountId = getQueryRoleByAccountId;
exports.resetDefaultPassword = resetDefaultPassword;
exports.validateAddSubAccount = validateAddSubAccount;
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _request = _interopRequireDefault(require("@/utils/request"));
function addSubAccount(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/ebSysAccount/addSubAccount',
    method: 'post',
    data: data
  });
}
function accountNameExist(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/ebSysAccount/validateUniqueAccountName',
    method: 'post',
    data: data
  });
}
function getQueryEbSysAccountSub(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/ebSysAccount/queryEbSysAccountSub',
    method: 'get',
    params: data
  });
}
function deleteSubAccountRolePort(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/ebSysAccountRole/deleteSubAccountRolePort',
    method: 'post',
    params: data
  });
}
function getLockSubAccount(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/ebSysAccount/lockSubAccount',
    method: 'get',
    params: data
  });
}
function resetDefaultPassword(sysAccountId) {
  return (0, _request.default)({
    url: '/sitceb-system-service/ebSysAccount/resetDefaultPassword/' + sysAccountId,
    method: 'get'
  });
}
function getQueryRoleByAccountId(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/ebSysAccountRole/queryRoleByAccountId',
    method: 'get',
    params: data
  });
}
function addSubAccountRolePort(data) {
  return (0, _request.default)({
    url: '/sitceb-system-service/ebSysAccountRole/addSubAccountRolePort',
    method: 'post',
    data: data
  });
}
function validateAddSubAccount() {
  return _validateAddSubAccount.apply(this, arguments);
}
function _validateAddSubAccount() {
  _validateAddSubAccount = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
    return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          return _context.abrupt("return", (0, _request.default)({
            url: '/sitceb-system-service/ebSysAccount/validateAddSubAccount',
            method: 'post'
          }));
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _validateAddSubAccount.apply(this, arguments);
}